import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import * as utils from "../../utils/components";
import { StyledScrollable } from "./Scrollable.styled";
var ScrollableBase = function (props) {
    var _a = props.vertical, vertical = _a === void 0 ? true : _a, _b = props.horizontal, horizontal = _b === void 0 ? false : _b, children = props.children;
    return (_jsx(StyledScrollable, { vertical: vertical, horizontal: horizontal, children: children }));
};
export var Scrollable = React.memo(ScrollableBase, utils.arePropsEqual);
